import React from 'react'

import { Card, SurveyHistoryStatus } from '@/components'
import { TSurveyHistoryData } from '@/libs/apis/queries/use-get-list-survey-history-query'
import formatDate from '@/libs/helpers/format-date'

export type TSurveyHistorySection = {
  readonly date: string
  readonly histories: TSurveyHistoryData[]
  readonly onClick: (id: string) => void
}

export default function SurveyHistorySection({ date, histories, onClick }: TSurveyHistorySection) {
  const formatedDate = formatDate(new Date(date))

  return (
    <div className='flex flex-col gap-4'>
      <span className='text-xs font-semibold text-pop-grey-500'>{formatedDate}</span>
      <Card noElevation>
        {histories.map((history, index) => (
          <div key={history?.id} className='w-full'>
            <button
              type='button'
              className='flex w-full cursor-pointer flex-col gap-4'
              onClick={() => onClick(history?.id)}
            >
              <section className='flex w-full flex-row items-center justify-between gap-3'>
                <span className='mr-3 line-clamp-2 text-xs font-normal'>{history?.name}</span>
                <SurveyHistoryStatus status={history?.status} />
              </section>
            </button>
            {index !== histories?.length - 1 && <hr className='mt-4' />}
          </div>
        ))}
      </Card>
    </div>
  )
}
